import {EntityFactory, Reducer} from '@modifi/redux'
import {OnboardingUserAndCompanyView} from '@modifi/onboarding-api-clients'

import {aFetchUser} from '../user'

type State = Record<string, any>
type Entity = NonNullable<OnboardingUserAndCompanyView['company']>

const {actions, selectors, reducer, actionTypes} = EntityFactory<State, Entity, any>({
  actionNamePrefix: 'data/company/entity',
  rootSelector: state => state?.data?.company?.current,
  fetchRequest: () => {
    throw new Error('Fetching not implemented')
  },
})

export const companyActionTypes = actionTypes!

export default reducer as Reducer

export const selectOnboardingCompany = (state: State): Entity | null =>
  selectors.selectEntity(state) ?? null

export const aUpdateLocalOnboardingCompany = (changes: Partial<Entity>, merge = true): any =>
  actions?.update(changes, merge)

export const aFetchCompany = aFetchUser

export const {selectIsLoading} = selectors
